export default __webpack_public_path__ + "static/media/buttonClick.c4850d07.mp3";